// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__AxvB2","list":"BalanceDue_list__EKfen","listRow":"BalanceDue_listRow__2UZKn","total":"BalanceDue_total__3ynfl"};